var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 50px 25px;\n  background-color: white;\n  margin: 50px auto;\n'], ['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 50px 25px;\n  background-color: white;\n  margin: 50px auto;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  height: 50%;\n  width: 50%;\n  margin: 20px auto;\n\n  @media (max-width: 1199.98px) {\n    height: 70%;\n    width: 70%;\n  }\n\n  @media (max-width: 991.98px) {\n    height: 80%;\n    width: 80%;\n  }\n'], ['\n  height: 50%;\n  width: 50%;\n  margin: 20px auto;\n\n  @media (max-width: 1199.98px) {\n    height: 70%;\n    width: 70%;\n  }\n\n  @media (max-width: 991.98px) {\n    height: 80%;\n    width: 80%;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  font-size: 24px;\n  font-weight: 700;\n  line-height: .95;\n  letter-spacing: -.3px;\n  text-align: center;\n  font-family: ', ';\n  color: ', ';\n  margin-bottom: 20px;\n'], ['\n  font-size: 24px;\n  font-weight: 700;\n  line-height: .95;\n  letter-spacing: -.3px;\n  text-align: center;\n  font-family: ', ';\n  color: ', ';\n  margin-bottom: 20px;\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 1.5;\n  color: ', ';\n  text-align: center;\n  font-family: ', ';\n'], ['\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 1.5;\n  color: ', ';\n  text-align: center;\n  font-family: ', ';\n']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n  border: 1px solid ', ';\n  color: ', ';\n  background-color: transparent;\n  border-radius: 0;\n  min-width: 120px;\n  white-space: nowrap;\n  cursor: pointer;\n  text-transform: uppercase;\n  font-size: 12px;\n  padding: 0.75rem 1.5rem;\n  margin-top: 1rem;\n'], ['\n  border: 1px solid ', ';\n  color: ', ';\n  background-color: transparent;\n  border-radius: 0;\n  min-width: 120px;\n  white-space: nowrap;\n  cursor: pointer;\n  text-transform: uppercase;\n  font-size: 12px;\n  padding: 0.75rem 1.5rem;\n  margin-top: 1rem;\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Container } from 'reactstrap';
import Theme from '../../Theme';
import notFound from '../../assets/img/404-toon.png';

export var NotFoundPage = styled.section(_templateObject);

export var NotFoundCartoon = styled.img(_templateObject2);

export var Title = styled.h3(_templateObject3, Theme.fonts.PlayfairDisplay, Theme.colors.primary);

export var Text = styled.p(_templateObject4, Theme.colors.blueGrey, Theme.fonts.Montserrat);

export var Button = styled.a(_templateObject5, Theme.colors.lightBlue, Theme.colors.lightBlue);

var NotFound = function NotFound(_ref) {
  var _ref$redirectLink = _ref.redirectLink,
      redirectLink = _ref$redirectLink === undefined ? '/' : _ref$redirectLink;
  return React.createElement(
    Container,
    null,
    React.createElement(
      NotFoundPage,
      null,
      React.createElement(
        Title,
        null,
        'We can\'t seem to find that page.'
      ),
      React.createElement(
        Text,
        null,
        'Either something went wrong or the page doesn\'t exist anymore.'
      ),
      React.createElement(
        Button,
        { href: redirectLink },
        'Home Page'
      ),
      React.createElement(NotFoundCartoon, { src: notFound })
    )
  );
};

NotFound.propTypes = process.env.NODE_ENV !== "production" ? {
  redirectLink: PropTypes.string
} : {};

export default NotFound;